import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  TableContainer,
  Text,
  Button,
} from "@chakra-ui/react";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Print_pdf_guardian = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [parentsData, setParentsData] = useState([]); // Renamed to avoid conflict with the parents state
  const printRef = useRef();

  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");

  // Fetch Parents API
  const fetchParents = async () => {
    setLoading(true);
    try {
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/guardian/list_all_guardian.php?school_id=${school_id}`
      );
      console.log(response);

      if (response.data.success === true && Array.isArray(response.data.data)) {
        setParentsData(response.data.data); // Updated to setParentsData instead of setParents
      } else {
        toast({
          title: "Error",
          description: "Unexpected data format.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Could not fetch data. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParents();
  }, []);

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  return (
    <div
      ref={printRef}
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.5",
      }}
    >
      {/* Header with Logo */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolImage ? `${schoolImage}` : ""}
          alt={`school Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolName}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolAddress}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolEmail}
          </p>
        </div>
      </div>

      {/* Table with Parents Data */}
      <TableContainer>
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
          style={{
            border: "1px solid #d4c2c2",
            borderCollapse: "collapse",
            width: "100%",
          }}
        >
          <Thead>
            <Tr>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Serial No.
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Guardian Name
              </Th>
              {/* <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>Email</Th> */}
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Student Name
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                {" "}
                Class
              </Th>

              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Phone
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Address
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {parentsData.map((parent, index) => (
              <Tr key={index}>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {index + 1}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {parent.name}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {parent.studentname}
                </Td>

                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {parent.class}
                </Td>

                {/* <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>{parent.email}</Td> */}
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {parent.contact_no}
                </Td>
                <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                  {parent.address}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
});

export default Print_pdf_guardian;
